import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'
import { delay } from 'lodash'
import { produce } from 'immer'
import { getInitialRecordProperty } from '../../logic/SM2+'
import {
  handleErrorInCatch,
  notSavedInAnonymous,
  notSavedInSharing,
  savingEnd,
  savingStart
} from '../../helper/functions'

export async function createTreeNode (id, input) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('createTreeNode start')
  }

  const data = {
    title: '',
    subtitle: '',
    expanded: true,
    // orderAsChild: 0,
    ...input,
    ...(getInitialRecordProperty())
  }
  const collectionReference = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('TreeNodes')
  try {
    savingStart()
    await collectionReference.doc(id).set(data)
    savingEnd()
  } catch (e) {
    handleErrorInCatch(e, 'createData.js')
  }

  return id
}
